
import { AbstractControl, AsyncValidatorFn, ValidationErrors} from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RuleService } from '../rule-custom-service';
  
  export class RulenameValidator {
    static createValidator(ruleservice:RuleService ,editstate:boolean): AsyncValidatorFn {
      return (control: AbstractControl): Observable<ValidationErrors> => {
        // console.log({editstate})
        if(editstate){
          return null
        }else{
          return ruleservice.checkIfRulenameExists(control.value)
          .pipe(
            map((result: any) =>{
              if(result.rulenameExists){ 
                return {rulenameAlreadyExists: true }
              }else{
                return null
              } 
            })
          );
        }
        
      };
    }
  }